import store from "../app/store";

export const getSettingVariable = (key, defaultValue = null) => {
    return store.getState().global.systemVariables?.[key] ?? defaultValue;
};

export const SETTINGS = new Proxy(
    {},
    {
        get(_, key) {
            const settingVariable = getSettingVariable(key); 
            console.log(`${key} : ${settingVariable}`);
            return settingVariable;
        },
    }
);